import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const VictorOpsShape = {
  service_key: Yup.string().label("Service API Key").min(36).max(36).required(),
  routing_key: Yup.string().label("Page ID").max(100).optional(),
};

export interface VictorOpsInput {
  service_key: string;
  routing_key?: string;
}

yupResolver<VictorOpsInput>(Yup.object().shape(VictorOpsShape));
